import React, { useState, useEffect } from 'react';
import './MaintenanceLock.css';

const MaintenanceLock = () => {
    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const res = await fetch('/api/health'); // Rota leve de check
                // Se a API retornar 503 com o flag de maintenance, ativamos o lock
                if (res.status === 503) {
                    const data = await res.json();
                    if (data.maintenance) {
                        setIsMaintenance(true);
                        return;
                    }
                }
                setIsMaintenance(false);
            } catch (err) {
                // Se o servidor cair, não travamos por manutenção, a UI lidará com o erro de rede
            }
        };

        // Verifica a cada 5 segundos se o sistema entrou em manutenção
        const interval = setInterval(checkStatus, 5000);
        checkStatus();

        return () => clearInterval(interval);
    }, []);

    if (!isMaintenance) return null;

    return (
        <div className="maintenance-overlay">
            <div className="maintenance-content">
                <div className="maintenance-icon">⚙️</div>
                <h2>Sincronização em Andamento</h2>
                <p>O sistema está sincronizando dados com o servidor remoto para sua segurança.</p>
                <div className="loader-line"></div>
                <p className="hint">Isso levará apenas alguns instantes. Não feche a página.</p>
            </div>
        </div>
    );
};

export default MaintenanceLock;
